





















import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'SlideShowTopBar',
  props: {
    isGridView: { type: Boolean },
    isLightboxView: { type: Boolean },
    route: { type: Object, default: () => ({}) },
  },
});
